
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState('');
  
  useEffect(() => {
    setIsVisible(true);
    
    // Set random background image only on client side after hydration
    const images = [
      '/assets/images/photo-1518495973542-4542c06a5843.webp',
      '/assets/images/photo-daliladalprat-2043569.webp',
      '/assets/images/photo-joey-kyber-31917-129743.webp',
      '/assets/images/photo-oleksandr-tiupa-53788-192136.webp'
    ];
    const selectedImage = images[Math.floor(Math.random() * images.length)];
    setBackgroundImage(selectedImage);
  }, []);

  // Use a default background for SSR and initial render
  const sectionStyle = backgroundImage 
    ? { backgroundImage: `url('${backgroundImage}')` }
    : { backgroundImage: "url('/assets/images/photo-1518495973542-4542c06a5843.webp')" };

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center pt-16"
      style={sectionStyle}
    >
      <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 z-0"></div>
      
      <div className="container-custom relative z-10 px-6">
        <div className="max-w-3xl">
          <h1
            className={`text-5xl md:text-6xl lg:text-7xl font-bold mb-8 text-white font-display transition-opacity ease-out duration-1000 ${
              isVisible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            Impelatek
          </h1>
          
          <h2 
            className={`text-2xl md:text-3xl font-medium text-white mb-8 transition-opacity ease-out duration-1000 delay-300 ${
              isVisible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {t('hero.subtitle')}
          </h2>
          
          <p 
            className={`text-xl leading-relaxed text-gray-100 max-w-2xl mb-10 transition-opacity ease-out duration-1000 delay-500 ${
              isVisible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {t('hero.description')}
          </p>
          
          <div 
            className={`transition-opacity ease-out duration-1000 delay-700 ${
              isVisible ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <a
              href="#contact"
              className="bg-developer-accent text-white px-8 py-4 rounded-md text-lg font-medium hover:bg-developer-accent-dark transition-colors duration-300"
            >
              {t('hero.cta')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
